import { useEffect, useState } from "react";
import { Boxes, Trash2 } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { api, errMsg } from "@/lib/api";
import { fmtDate } from "@/lib/format";

const TONE = { expired: "border-rose-300 bg-rose-50 text-rose-700", expiring: "border-amber-300 bg-amber-50 text-amber-800", fresh: "border-emerald-200 bg-emerald-50 text-emerald-800" };
const LABEL = { expired: "Expired", expiring: "Use today", fresh: "Fresh" };

export function StockLots() {
  const [lots, setLots] = useState([]);
  const load = () => api.get("/stock/lots").then((r) => setLots(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);
  const writeOff = async (l) => {
    try { await api.post(`/stock/lots/${l.id}/write-off`, { reason: l.state === "expired" ? "Expired" : "Quality" }); toast.success(`${l.code} written off`); load(); }
    catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div className="mt-8 rounded-2xl border border-[#E7E2D6] bg-white p-5" data-testid="stock-lots">
      <div className="flex items-center gap-2 font-display text-lg font-semibold text-[#0F382C]"><Boxes className="h-5 w-5" />Batch stock & expiry (oldest first)</div>
      <p className="text-sm text-muted-foreground mb-3">Each recorded production creates batches. Deliveries automatically use the oldest unexpired batch first. Set shelf life per product on the Products page.</p>
      {lots.length === 0 ? <div className="text-sm text-muted-foreground">No batch stock left.</div> : (
        <div className="space-y-2">
          {lots.map((l) => (
            <div key={l.id} className={`flex flex-wrap items-center justify-between gap-2 rounded-xl border px-3 py-2 text-sm ${TONE[l.state]}`} data-testid={`lot-${l.id}`}>
              <span><b className="font-mono">{l.code}</b> · {l.name} · <b>{l.qty_left}</b> left · made {fmtDate(l.made_on)} · use by {fmtDate(l.expires_on)}</span>
              <span className="flex items-center gap-2">
                <span className="text-xs font-bold uppercase" data-testid={`lot-state-${l.id}`}>{LABEL[l.state]}</span>
                {l.state !== "fresh" && <Button size="sm" variant="ghost" onClick={() => writeOff(l)} data-testid={`lot-writeoff-${l.id}`}><Trash2 className="h-4 w-4" /></Button>}
              </span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
